var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPaginationArrowLeft({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.30188 11.1913L13.613 5.34149C13.8084 5.11394 14.0526 5 14.3462 5C14.6398 5 14.8838 5.11394 15.0795 5.34149L15.6984 6.01535C15.8993 6.23725 16 6.50667 16 6.82424C16 7.14181 15.8996 7.4084 15.6984 7.64194L11.7395 12.0002L15.6987 16.3675C15.8996 16.5891 16 16.8585 16 17.1761C16 17.4936 15.8996 17.7602 15.6987 17.9938L15.0795 18.6676C14.8787 18.8892 14.6341 19 14.3462 19C14.0583 19 13.8138 18.8892 13.613 18.6676L8.30159 12.8179C8.10044 12.5843 8 12.3118 8 12.0002C8 11.6826 8.10072 11.4132 8.30159 11.1913H8.30188Z"
  })));
}

export default SvgPaginationArrowLeft;